import axios from 'axios';
import { fetchToken } from '../fetchToken';
import { logError } from '../../taskpane/utils/request';
const API_URL = process.env.EMAILS_API_URL;

/**
 * Get object from Salesforce using objectApiName and fieldSets
 * @param {*} objectApiName
 * @param {*} fieldSet
 * @return {*} api response
 */
export const getObject = async (objectApiName, fieldSet) => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: `${API_URL}objects?objectApiName=${objectApiName}&fieldSet=${fieldSet}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

/**
 * Create a new object record in salesforce with the properties passed in
 * @param {string} objectApiName
 * @param {object} objectRecordParams
 *
 * @return {Promise} - A promise with the reponse from the lamda function.
 *
 * @throws {Error} - Throws a Error if creating object in salesforce fails
 *
 * @example
 * // Example of how to use the function
 * const response = await postObject('Task', { OwnerId: "005RL000007t9d7YAA", CallType: 'Internal'});
 */
export const postObjectRecord = async (objectApiName, objectRecordParams) => {
  const token = await fetchToken();
  const config = {
    method: 'POST',
    url: `${API_URL}objects?objectApiName=${objectApiName}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: objectRecordParams,
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};
